import React from "react";
import styled from "styled-components";
import ArrowNext from "./ArrowNext";
import { ICustomer } from "../../interfaces/customer";
import { Avatar } from "react-rainbow-components";

const Container = styled.li`
  display: flex;
`;

const ContainerCustomer = styled.article`
  display: flex;
  padding: 1rem;
  border-radius: 16px;
  background: ${(props: { show: boolean }) =>
    props.show
      ? "linear-gradient(to left, rgba(9,132,227,0.58), rgba(9,132,227,0.65), rgba(9,132,227,0.55))"
      : "#fff"};
  width: fit-content;
  height: fit-content;
  margin: 0.25rem 0.5rem;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.25);
  justify-content: center;
  align-items: center;
`;

const ImageProfile = styled(Avatar)`
  border-radius: 16px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.25);
  width: 3rem;
  height: 3rem;
  min-width: 3rem;
  margin-right: 1rem;
`;

const TextDescription = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const ProfileName = styled.p`
  font-size: 18px;
  font-weight: 600;
  font-family: "Prompt";
  color: ${(props: { show: boolean }) =>
    props.show ? "rgb(255, 255, 255, 1)" : "rgba(18, 53, 89, 1)"};
  margin: 0;
`;
const CaseIdText = styled.p`
  font-size: 14px;
  font-family: "Prompt";
  color: ${(props: { show: boolean }) =>
    props.show ? "rgb(255, 255, 255, 0.7)" : "rgba(18, 53, 89, 0.7)"};
  margin: 0;
  width: 270px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ArrowContainer = styled.div`
  width: 46px;
  height: 46px;
  margin: 1rem;
  align-items: center;
  justify-content: center;
  display: flex;
`;

const CustomerComponent = (props: {
  customer: ICustomer;
  Toggle: () => void;
  show: boolean;
}) => {
  const pet = props.customer.pets?.find(
    (pet) => pet.pid === props.customer.pid
  );
  return (
    <Container>
      <ContainerCustomer onClick={props.Toggle} show={props.show}>
        <ImageProfile
          src={props.customer.imageUrl}
          title={props.customer.displayName}
          assistiveText={props.customer.displayName}
          initials={props.customer.displayName}
        />
        <TextDescription>
          <ProfileName show={props.show}>
            {props.customer.displayName} ({pet?.petName})
          </ProfileName>
          <CaseIdText show={props.show}>
            {props.customer.descriptions}
          </CaseIdText>
        </TextDescription>
      </ContainerCustomer>
      <ArrowContainer>
        <ArrowNext showArrow={props.show} />
      </ArrowContainer>
    </Container>
  );
};

export default CustomerComponent;
